// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Ci1T","right":"Footer_right__14BYk","buttons":"Footer_buttons__2xU07"};